import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getApiUrl } from '../../config/api';
import { RootState } from '../index';

export interface SynthflowAgent {
  id: number;
  model_id: string;
  name: string;
  phone_number?: string;
  type?: string;
  webhook_url?: string;
  webhook_enabled: boolean;
}

export const synthflowAgentsApi = createApi({
  reducerPath: 'synthflowAgentsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: getApiUrl('/api/v1/synthflow-agents'),
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.token;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
        console.log('🔑 RTK Query: Added auth token to headers');
      } else {
        console.warn('⚠️ RTK Query: No auth token found in state');
      }
      return headers;
    },
  }),
  tagTypes: ['SynthflowAgent'],
  endpoints: (builder) => ({
    getAgentsForAccount: builder.query<SynthflowAgent[], number>({
      query: (accountId) => `/account/${accountId}`,
      providesTags: (result, error, accountId) => [
        { type: 'SynthflowAgent', id: accountId },
      ],
    }),
    toggleAgentWebhook: builder.mutation<
      { status: string; message: string; agent_id: number; agent_name: string; webhook_enabled: boolean },
      { agentId: number; enabled: boolean }
    >({
      query: ({ agentId, enabled }) => {
        console.log('🌐 RTK Query: Making webhook toggle request:', {
          url: `/${agentId}/webhook/toggle`,
          method: 'PUT',
          body: { enabled },
          fullUrl: `/api/v1/synthflow-agents/${agentId}/webhook/toggle`
        });
        return {
          url: `/${agentId}/webhook/toggle`,
          method: 'PUT',
          body: { enabled },
        };
      },
      invalidatesTags: (result, error, { agentId }) => [
        { type: 'SynthflowAgent', id: agentId },
      ],
    }),
           getAgentWebhookStatus: builder.query<
             { status: string; agent_id: number; agent_name: string; webhook_url?: string; webhook_enabled: boolean; message: string },
             number
           >({
             query: (agentId) => `/${agentId}/webhook/status`,
           }),
    syncSynthflowAgents: builder.mutation<{ total_agents_fetched: number; total_agents_created: number; total_agents_updated: number; started_at: string; completed_at: string }, void>({
      query: () => ({
        url: '/sync',
        method: 'POST',
      }),
      invalidatesTags: ['SynthflowAgent'],
    }),
  }),
});

export const {
  useGetAgentsForAccountQuery,
  useToggleAgentWebhookMutation,
  useGetAgentWebhookStatusQuery,
  useSyncSynthflowAgentsMutation,
} = synthflowAgentsApi;
